import script from "./AddSubhiresModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSubhiresModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSubhiresModal.vue?vue&type=style&index=0&id=30230e50&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30230e50"]])

export default __exports__